import {
  alpha, Box, Menu, styled,
} from '@mui/material';
import { scrollbarStyle4 } from '../../../../../../../styles/scrollbarStyles';
import { spaceCadet } from '../../../../../../../utils/colors';

const StyledBox = styled(Box)(() => ({
  '& .MuiButton-root': {
    color: spaceCadet[100],
    gap: 4,
    display: 'flex',
    alignItems: 'center',
    '& img': {
      height: 15,
      width: 21,
    },
    '& > .MuiTypography-root': {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 600,
      textTransform: 'none',
    },
  },
}));

export const StyledMenu = styled(Menu)(() => ({
  width: 300,
  maxHeight: 400,
  '& .MuiPaper-root': {
    ...scrollbarStyle4,

    '& .MuiList-root': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'flex-start',
      padding: 0,
      '& .MuiMenuItem-root': {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        '& img': {
          height: 15,
          width: 21,
        },
        padding: '8px 16px',
        borderBottom: `1px solid ${alpha(spaceCadet[300], 0.3)}`,
        fontSize: 14,
        lineHeight: '20px',
      },
    },
  },
}));
export default StyledBox;
